const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtpSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ebebeb"
    },
    transform: "translate(839.3 791.48) rotate(180)",
    height: 11.19,
    width: 35.16,
    y: 390.15,
    x: 402.07
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ebebeb"
    },
    transform: "translate(411.93 430.75) rotate(180)",
    height: 11.19,
    width: 35.16,
    y: 209.78,
    x: 188.39
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M421.68,415.45l17.7-.3,8.75-.12,8.71,0-.46.46,0-11.19.5.5-17.58-.07-8.79-.09-8.79-.11.24-.23Zm0,0-.23-11.19V404h.24l8.79-.11,8.79-.09,17.58-.06h.5v.51l0,11.19v.45h-.45l-8.87,0-8.83-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M254.5,332l17.7-.29,8.75-.12,8.71-.05-.46.46,0-11.19.5.5-17.58-.07-8.79-.08-8.79-.11.24-.24Zm0,0-.24-11.19v-.23h.24l8.79-.11,8.79-.08,17.58-.07h.5v.5L290.11,332v.46h-.45l-8.87-.05-8.83-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M274.11,346.14l17.7-.29,8.75-.12,8.71-.05-.46.46,0-11.19.5.5-17.58-.07-8.79-.08-8.79-.11.24-.24Zm0,0L273.87,335v-.23h.24l8.79-.11,8.79-.08,17.58-.07h.5v.5l0,11.19v.46h-.45l-8.87-.05-8.83-.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ebebeb"
    },
    transform: "translate(622.45 652.87) rotate(180)",
    height: 11.19,
    width: 35.16,
    y: 320.84,
    x: 293.65
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ebebeb"
    },
    transform: "translate(121.48 819.7) rotate(180)",
    height: 11.19,
    width: 35.16,
    y: 404.26,
    x: 43.16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ebebeb"
    },
    transform: "translate(160.7 101.06) rotate(180)",
    height: 11.19,
    width: 35.16,
    y: 44.93,
    x: 62.77
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M43.16,70.23l17.7-.29,8.75-.12,8.71,0-.46.45,0-11.19.5.5-17.58-.07L52,59.39l-8.79-.11L43.4,59Zm0,0L42.92,59v-.23h.24L52,58.7l8.79-.09,17.58-.07h.5V59l0,11.19v.46h-.45l-8.87,0-8.83-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M402.07,56.12l17.7-.29,8.75-.12,8.71,0-.46.45,0-11.19.5.5-17.58-.07-8.79-.08-8.79-.11.24-.24Zm0,0-.24-11.19V44.7h.24l8.79-.11,8.79-.09,17.58-.07h.5v.5l-.05,11.19v.46h-.45l-8.87,0-8.83-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ebebeb"
    },
    points: "332.04 441.43 448.8 441.43 452.56 367.34 328.28 367.34 332.04 441.43"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb"
    },
    d: "M440.29,401.3H337.37L336,375.49h106Zm-102-1h101l1.53-23.81H337Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb"
    },
    d: "M438.89,430.89H340.32l-1.15-23.3H440.35Zm-97.61-1H438l1.33-21.3H340.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb"
    },
    d: "M400.69,391.23H378.81l-.81-6.29h23.5Zm-21-1h20.12l.56-4.29H379.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb"
    },
    d: "M400.69,422.39H378.81l-.81-6.3h23.5Zm-21-1h20.12l.56-4.3H379.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ebebeb"
    },
    points: "348.23 441.43 347.1 449.5 344.82 465.72 340.36 465.72 340.36 441.43 348.23 441.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#dbdbdb"
    },
    points: "348.23 441.43 347.1 449.5 340.36 449.5 340.36 441.43 348.23 441.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ebebeb"
    },
    points: "432.61 441.43 433.74 449.5 436.02 465.72 440.48 465.72 440.48 441.43 432.61 441.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#dbdbdb"
    },
    points: "432.61 441.43 433.74 449.5 440.48 449.5 440.48 441.43 432.61 441.43"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M459.23,182.73H291.17V38.09H459.23Zm-167.06-1H458.23V39.09H292.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6"
    },
    d: "M299.55,43.63a2,2,0,1,1-2-2.05A2,2,0,0,1,299.55,43.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M307.9,43.63a2,2,0,1,1-2-2.05A2,2,0,0,1,307.9,43.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M316.25,43.63a2,2,0,1,1-2.05-2.05A2,2,0,0,1,316.25,43.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ebebeb"
    },
    height: 1,
    width: 167.06,
    y: 48.11,
    x: 291.67
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M401.83,354.74A43.73,43.73,0,0,1,401,371.6a46.54,46.54,0,0,1-2.58,7.45c-1.34,3.09-2.74,6.1-2.41,9.47.33.22-.79.19-.83-.14-9-5.14-20.58-6.08-27.52-14.48-3.29-4-4.95-9-5.74-14-.85-5.49-1.09-11.57.33-17,1.19-4.57,3.87-9,8.16-11.23,4.44-2.31,10.25-2.11,14.93-.66C395.4,334.11,400.41,345,401.83,354.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M406.47,421.51c-1.24-4.1-2.47-8.21-3.73-12.3-2.47-8-5.05-16-7.9-23.9q-2.55-7.1-5.39-14.05a85.91,85.91,0,0,1,1.07-8.71c.76-3.5,1.85-6.88,2.87-10.3.06-.21-.28-.32-.36-.12-2,4.71-4.67,10.74-4.74,16.33-2.2-5.25-4.55-10.42-7.09-15.52a66.57,66.57,0,0,1,.4-12.92c0-.2-.27-.26-.3-.06a45.28,45.28,0,0,0-.88,11.41q-2.91-5.75-6.16-11.34c-.2-.33-.66,0-.49.34q5.09,9.79,9.49,19.94a43.43,43.43,0,0,0-14.15-8.18c-.22-.09-.39.24-.16.34a51.67,51.67,0,0,1,15.3,10.12q3.18,7.43,6.06,15c-5.65-5.53-13.37-9.17-20.84-11.12-.25-.07-.32.32-.08.4,8.65,2.6,15.37,7.5,21.94,13.39.76,2,1.51,4.07,2.25,6.1q4.17,11.6,8,23.33,1.81,5.63,3.58,11.26c1.26,4.05,2.25,8.32,3.89,12.22.15.38.82.29.74-.15A117,117,0,0,0,406.47,421.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M391.5,346.84a22.66,22.66,0,0,0-3.25,8.1c0,.07.11.12.13,0a69.5,69.5,0,0,1,3.53-7.94C392,346.77,391.66,346.61,391.5,346.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M375.41,365.63a23.89,23.89,0,0,0-8.09-2.72c-.08,0-.12.1-.05.13,1.31.54,2.67.92,4,1.42s2.61,1.13,3.95,1.59A.23.23,0,0,0,375.41,365.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M370.88,343a15.28,15.28,0,0,0-2.61-1.61.14.14,0,0,0-.15.23,16.11,16.11,0,0,0,2.57,1.66C370.86,343.41,371,343.13,370.88,343Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M432.24,385.37c-6.49,1.93-13,3.71-19.52,5.62-.56.17-11.54-20.88-7.58-31.72,3.67-10,12.07-17.54,22.09-20.95,4.63-1.57,10.34-2.9,15.24-1.82,4.35,1,7.43,4.53,8.85,8.63,1.93,5.57,1.28,12.21.23,17.9a31.25,31.25,0,0,1-6.39,14.61C441.71,381.74,437.31,383.87,432.24,385.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M441.66,365.37a86.23,86.23,0,0,1-12.74,5,53.72,53.72,0,0,0-8.5,3.07c2.74-6.11,5.76-12.1,8.95-18,4.2-1.22,8.61-3.11,11.78-6.08a.18.18,0,0,0-.24-.28c-3.46,2.45-7.28,3.92-11.11,5.57.87-1.59,1.74-3.19,2.63-4.78.24-.44-.37-.88-.66-.45a135.93,135.93,0,0,0-9.23,15.5,70.15,70.15,0,0,1-.67-14.2.1.1,0,0,0-.19,0,47.28,47.28,0,0,0,.16,15.61c-2.28,4.55-4.36,9.21-6.22,13.92-.74-2.83-1.7-5.62-2.35-8.48a39,39,0,0,1-.93-12.5.1.1,0,0,0-.19,0,44.06,44.06,0,0,0,2.73,23c-1.09,2.84-2.12,5.69-3.07,8.54a170.29,170.29,0,0,0-8.62,45.08.27.27,0,0,0,.54,0,223.86,223.86,0,0,1,9.69-44.55c1.88-5.66,4.05-11.16,6.43-16.56,3.83-1.13,7.66-2.67,11.43-4s7.44-2.75,10.53-5.17C441.93,365.5,441.8,365.3,441.66,365.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M447.72,359.26c-4,1.41-7.74,3.39-11.71,4.82-.18.07-.08.36.11.33,4.2-.87,8.37-2.17,11.75-4.92C448,359.38,447.86,359.21,447.72,359.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M415.28,350.69c.05-.21-.26-.33-.33-.12-1.09,3.66-1.84,7.55-.78,11.29,0,.15.27.16.28,0C414.64,358.07,414.43,354.4,415.28,350.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M431.69,342.23a9.67,9.67,0,0,0-1.72,6.22c0,.14.23.23.27.06.48-2.09,1.29-4,1.93-6A.27.27,0,0,0,431.69,342.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M355,394.65c1.91,6.05,6.43,14.4,13.6,14.47,4.64,0,9.32-.51,14-.57,5-.08,10-.07,15,.23.41,0-.6-14.93-12.58-22.22-3.36-2-7.47-2.68-11.28-3.51a52.42,52.42,0,0,0-13.32-1.39c-2.75.11-5,.7-6,3.52S354.06,391.78,355,394.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M360.13,387.09c2.91.75,5.85,1.61,8.77,2.54a31.59,31.59,0,0,0-2.41-2.36c-1.26-1-2.64-1.88-4-2.79-.11-.08,0-.29.1-.24a16.47,16.47,0,0,1,7.07,5.63c3.64,1.17,7.25,2.47,10.73,3.9a41,41,0,0,1,6.86,3.61,27.61,27.61,0,0,0-2.48-4.32c-1.59-2.06-3.75-3.21-5.83-4.67a.19.19,0,0,1,.19-.32,17.07,17.07,0,0,1,9.35,10.13,39.9,39.9,0,0,1,6.8,6.18c7.93,9,14.17,21,14.19,33.22,0,.29-.46.37-.52.07a67.84,67.84,0,0,0-15.12-32.49c-.57-.66-1.15-1.29-1.75-1.9a53,53,0,0,0-6.55-.48c-2.55,0-5.08.37-7.62.58-4.19.34-8.81.39-12.59-1.72-.16-.09-.05-.38.14-.31,8.41,3.06,17.23-.83,25.67,1a39.46,39.46,0,0,0-12.44-8l-.77-.31c-5.4.65-11.1,2.05-16.36.3a.13.13,0,0,1,.06-.25c5.09,1.27,10-.33,15-.58-5.46-2.13-11-3.82-16.5-5.93C359.64,387.38,359.63,387,360.13,387.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M357.74,392.41a74,74,0,0,0,7.86.59c.06,0,.08.1,0,.11a16.41,16.41,0,0,1-7.93-.5A.1.1,0,0,1,357.74,392.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M375.5,387.22a12.86,12.86,0,0,1,3.89,2.71c.13.12-.05.36-.2.25-.66-.48-1.34-.93-2-1.37a18.47,18.47,0,0,1-1.9-1.2C375.09,387.46,375.28,387.15,375.5,387.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M417.82,406.68c-.09.2.2.39.31.18h0a.29.29,0,0,0,.19.12A119.54,119.54,0,0,0,433,409.52c4,.36,8.53.58,12-1.72,4.7-3.12,7.79-11.45,5.25-16.75-3-6.29-12.07-2.87-16.61-.64A33.34,33.34,0,0,0,417.82,406.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M414.3,409.59a47.06,47.06,0,0,1,8.75-6.66,29.92,29.92,0,0,1,8.86-9c.18-.12.32.15.17.27A40.31,40.31,0,0,0,424.6,402a82.85,82.85,0,0,1,11-5,14.63,14.63,0,0,1,5.9-5.9s.11,0,.06.08a24,24,0,0,0-5.32,5.58c2.22-.83,4.48-1.6,6.73-2.35.2-.06.27.24.08.32-4,1.56-8.1,3.21-12.07,5.12a46.56,46.56,0,0,0,14.62-.05c.13,0,.19.17.06.21a28.87,28.87,0,0,1-15.51.23,74.49,74.49,0,0,0-7.36,4.12,18.53,18.53,0,0,1,5.95.49,45.39,45.39,0,0,0,10.45,1.18.12.12,0,0,1,0,.24c-6.06,1-11.79-1.71-17.8-1a46.45,46.45,0,0,0-6.25,5.11A47.15,47.15,0,0,0,406,423.29c-2.53,5.15-3.9,10.6-5.94,15.92a.19.19,0,0,1-.37-.1C401.45,428.63,406.67,417.06,414.3,409.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M432.58,395.21a6.83,6.83,0,0,1,1.55-1.88,6.13,6.13,0,0,1,1.79-1.34.06.06,0,0,1,.06.1c-.5.57-1.19,1-1.72,1.52s-1,1.18-1.54,1.71C432.65,395.4,432.54,395.3,432.58,395.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M442.58,398.47c.89-.23,1.85-.21,2.76-.4s1.78-.52,2.68-.8a.11.11,0,0,1,.08.2,8.9,8.9,0,0,1-5.52,1.28A.14.14,0,0,1,442.58,398.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474f"
    },
    points: "389.33 426.19 390.13 435.22 392.83 465.72 416.71 465.72 420.09 435.22 421.08 426.19 389.33 426.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "389.33 426.19 390.13 435.22 420.09 435.22 421.08 426.19 389.33 426.19"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#37474f"
    },
    transform: "translate(810.42 854.78) rotate(180)",
    height: 7.33,
    width: 36.48,
    y: 423.73,
    x: 386.97
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "47.44 465.72 98.08 465.48 148.72 465.39 250 465.22 351.28 465.39 401.92 465.48 452.56 465.72 401.92 465.97 351.28 466.06 250 466.22 148.72 466.06 98.08 465.97 47.44 465.72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    height: 232.98,
    width: 368.27,
    y: 56.63,
    x: 65.86
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M434.14,289.61l-368.28.15h-.15v-.15l-.09-233v-.25h.24l368.28.15h.09v.1Zm0,0-.1-233,.1.09-368.28.15.25-.24-.09,233-.16-.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#263238"
    },
    height: 8.96,
    width: 368.27,
    y: 56.63,
    x: 65.86
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M74.51,61.11A1.81,1.81,0,1,1,72.7,59.3,1.8,1.8,0,0,1,74.51,61.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M81.89,61.11a1.81,1.81,0,1,1-1.81-1.81A1.8,1.8,0,0,1,81.89,61.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M89.26,61.11a1.81,1.81,0,1,1-1.81-1.81A1.8,1.8,0,0,1,89.26,61.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ebebeb"
    },
    height: 49.91,
    width: 38.06,
    y: 178.34,
    x: 139.29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ebebeb"
    },
    height: 49.91,
    width: 38.06,
    y: 178.34,
    x: 185.13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ebebeb"
    },
    height: 49.91,
    width: 38.06,
    y: 178.34,
    x: 230.97
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ebebeb"
    },
    height: 49.91,
    width: 38.06,
    y: 178.34,
    x: 276.81
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ebebeb"
    },
    height: 49.91,
    width: 38.06,
    y: 178.34,
    x: 322.65
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7"
    },
    d: "M163.82,200.73a9.09,9.09,0,0,1,2.72,6.55,9.24,9.24,0,0,1-2.72,6.52,9.09,9.09,0,0,1-6.52,2.72h-.07a9,9,0,0,1-6.48-2.72,2,2,0,0,1,0-3,2.11,2.11,0,0,1,3,0,4.83,4.83,0,0,0,3.57,1.49,4.89,4.89,0,0,0,3.54-1.49,5.05,5.05,0,0,0,1.49-3.54,5,5,0,0,0-5-5,4.92,4.92,0,0,0-3.57,1.46,2.11,2.11,0,0,1-3,0c-.15-.15-.27-.34-.41-.49s0-.11,0-.11a.3.3,0,0,0-.08-.19c0-.11,0-.18,0-.26s0,0,0-.07a1.67,1.67,0,0,1,0-.63l1.12-9.65a2.2,2.2,0,0,1,.93-1.49c.07,0,.11,0,.15-.08s.07,0,.11-.07a2,2,0,0,1,1-.23h11a2.11,2.11,0,1,1,0,4.21h-9.17l-.44,3.69a9.68,9.68,0,0,1,2.49-.33A9.09,9.09,0,0,1,163.82,200.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7"
    },
    d: "M209.65,200.69a9.13,9.13,0,0,1,2.72,6.52,9.25,9.25,0,0,1-15.8,6.56,2.11,2.11,0,0,1,3-3,5,5,0,0,0,3.54,1.45,5.17,5.17,0,0,0,3.58-1.45,5,5,0,0,0,1.49-3.58,4.88,4.88,0,0,0-1.49-3.54,5,5,0,0,0-3.54-1.49,1.82,1.82,0,0,1-1.53-.67s0,0,0,0a2.12,2.12,0,0,1-.07-3l3.8-3.87h-6a2.11,2.11,0,0,1,0-4.21h11a2.09,2.09,0,0,1,2.13,2.08,2.26,2.26,0,0,1-.26,1,2.9,2.9,0,0,1-.38.52L207,198.86A8.62,8.62,0,0,1,209.65,200.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7"
    },
    d: "M255.49,200.69a9.13,9.13,0,0,1,2.72,6.52,9.25,9.25,0,0,1-15.8,6.56,2.11,2.11,0,1,1,3-3,5,5,0,0,0,3.54,1.45,5.17,5.17,0,0,0,3.58-1.45,5,5,0,0,0,1.49-3.58,4.88,4.88,0,0,0-1.49-3.54,5,5,0,0,0-3.54-1.49,1.82,1.82,0,0,1-1.53-.67s0,0,0,0a2.1,2.1,0,0,1-.07-3l3.8-3.87h-6a2.11,2.11,0,0,1,0-4.21h11a2.09,2.09,0,0,1,2.13,2.08,2.26,2.26,0,0,1-.27,1,2.44,2.44,0,0,1-.37.52l-4.69,4.84A8.62,8.62,0,0,1,255.49,200.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7"
    },
    d: "M304.74,207.66a8.91,8.91,0,1,1-13.82-7.42,6,6,0,0,1-1.23-3.69,6.15,6.15,0,0,1,12.3,0,6,6,0,0,1-1.23,3.69A8.94,8.94,0,0,1,304.74,207.66Zm-4.06,0a4.85,4.85,0,0,0-4.8-4.85,4.83,4.83,0,1,0,0,9.65A4.81,4.81,0,0,0,300.68,207.66Zm-6.93-11.11a2.09,2.09,0,1,0,4.18,0,2.09,2.09,0,0,0-4.18,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d2232a"
    },
    height: 16.96,
    width: 54.12,
    y: 245.72,
    x: 222.94
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M234.47,255.51a.44.44,0,0,1,.62-.06,2.76,2.76,0,0,0,1.6.65,1.83,1.83,0,0,0,1-.31.78.78,0,0,0,.36-.61.5.5,0,0,0-.07-.27,1,1,0,0,0-.25-.25,3.4,3.4,0,0,0-1.15-.39h0a4.88,4.88,0,0,1-1.08-.33,1.84,1.84,0,0,1-.78-.65,1.35,1.35,0,0,1-.19-.69,1.53,1.53,0,0,1,.67-1.22,2.43,2.43,0,0,1,1.45-.45,3.37,3.37,0,0,1,1.83.67.43.43,0,0,1,.11.6.42.42,0,0,1-.59.13,2.41,2.41,0,0,0-1.35-.54,1.66,1.66,0,0,0-.94.28.67.67,0,0,0-.32.53.45.45,0,0,0,.06.24.8.8,0,0,0,.23.21,2.75,2.75,0,0,0,1,.37h0a5.27,5.27,0,0,1,1.16.35,2.06,2.06,0,0,1,.84.7,1.4,1.4,0,0,1,.2.71,1.64,1.64,0,0,1-.72,1.3,2.67,2.67,0,0,1-1.55.48,3.61,3.61,0,0,1-2.15-.84A.45.45,0,0,1,234.47,255.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M242.67,257a2.42,2.42,0,0,1-2.42-2.43v-3a.45.45,0,0,1,.46-.46.47.47,0,0,1,.47.46v3a1.5,1.5,0,1,0,3,0v-3a.47.47,0,0,1,.93,0v3A2.43,2.43,0,0,1,242.67,257Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M247.06,256.51v-4.95a.46.46,0,0,1,.46-.46h1.19a1.59,1.59,0,0,1,1.59,1.59,1.54,1.54,0,0,1-.32,1A1.79,1.79,0,0,1,249,257h-1.48a0,0,0,0,1,0,0h0A.47.47,0,0,1,247.06,256.51Zm.93-3.14h.72a.67.67,0,0,0,.66-.68.66.66,0,0,0-.66-.66H248Zm0,2.67h1a.87.87,0,0,0,0-1.74h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M257.08,251.56v4.95a.47.47,0,0,1-.47.46.46.46,0,0,1-.46-.46V253l-1.21,1.67a.44.44,0,0,1-.37.2h0a.49.49,0,0,1-.39-.2L253,253v3.53a.47.47,0,0,1-.93,0v-4.95a.47.47,0,0,1,.46-.46h0a.45.45,0,0,1,.37.19l1.67,2.32,1.66-2.32a.49.49,0,0,1,.38-.19h0A.48.48,0,0,1,257.08,251.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M259.16,251.56a.45.45,0,0,1,.46-.46.47.47,0,0,1,.47.46v4.95a.47.47,0,0,1-.47.46.45.45,0,0,1-.46-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M265.24,252h-1.33v4.48a.45.45,0,0,1-.46.46.46.46,0,0,1-.46-.46V252h-1.32a.47.47,0,0,1-.46-.47.45.45,0,0,1,.46-.46h3.57a.45.45,0,0,1,.46.46A.47.47,0,0,1,265.24,252Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M257.06,97.48v7.61H254.9V97.48a4.91,4.91,0,1,0-9.8,0v7.61h-2.16V97.48a7.07,7.07,0,1,1,14.12,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#c7c7c7"
    },
    points: "242.94 99.45 245.1 99.54 245.1 105.09 242.94 105.09 242.94 99.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#c7c7c7"
    },
    points: "257.06 100.03 257.06 105.09 254.9 105.09 254.9 99.94 257.06 100.03"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d2232a"
    },
    height: 16.29,
    width: 19.63,
    y: 102.27,
    x: 240.19
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M250.83,110.31l.82,3.89h-3.49l.83-3.89a1.74,1.74,0,0,1,.92-3.22,1.74,1.74,0,0,1,.92,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M143.62,159.53a.22.22,0,0,1,.22-.22h1.81a1.83,1.83,0,0,1,0,3.65l-1.58,0v2.51a.22.22,0,0,1-.23.22.22.22,0,0,1-.22-.22Zm2,3a1.4,1.4,0,0,0,1.38-1.39,1.38,1.38,0,0,0-1.38-1.38h-1.58v2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M148.92,159.53a.22.22,0,0,1,.21-.22.22.22,0,0,1,.23.22v6a.22.22,0,0,1-.23.22.22.22,0,0,1-.21-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M151.22,163.48a2.17,2.17,0,1,1,4.33-.16h0v0a.21.21,0,0,1-.22.21h-3.67a1.75,1.75,0,0,0,1.73,1.71,1.69,1.69,0,0,0,1.45-.81.2.2,0,0,1,.29-.07.23.23,0,0,1,.07.31,2.13,2.13,0,0,1-1.81,1A2.2,2.2,0,0,1,151.22,163.48Zm.46-.35h3.4a1.73,1.73,0,0,0-1.69-1.46A1.76,1.76,0,0,0,151.68,163.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M160.86,161.45v4a.22.22,0,0,1-.44,0v-.66a2.07,2.07,0,0,1-1.68.88,2.24,2.24,0,0,1,0-4.48,2.07,2.07,0,0,1,1.68.88v-.66a.22.22,0,0,1,.44,0Zm-.44,2a1.68,1.68,0,1,0-1.68,1.8A1.75,1.75,0,0,0,160.42,163.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M162.45,164.78a.22.22,0,0,1,.31,0,2.4,2.4,0,0,0,1.37.52A1.37,1.37,0,0,0,165,165a.69.69,0,0,0,.34-.55.7.7,0,0,0-.32-.55,2.39,2.39,0,0,0-.95-.33h0a2.5,2.5,0,0,1-1-.34.94.94,0,0,1-.49-.81,1.13,1.13,0,0,1,.49-.88,1.94,1.94,0,0,1,1.1-.3,2.41,2.41,0,0,1,1.33.49.22.22,0,0,1,.06.31.21.21,0,0,1-.3.06,2,2,0,0,0-1.09-.45,1.36,1.36,0,0,0-.85.26.67.67,0,0,0-.29.51.53.53,0,0,0,.26.45,2.14,2.14,0,0,0,.91.31h0a3.11,3.11,0,0,1,1.09.37,1.12,1.12,0,0,1,.5.91,1.15,1.15,0,0,1-.51.91,1.89,1.89,0,0,1-1.12.35,2.66,2.66,0,0,1-1.65-.64A.21.21,0,0,1,162.45,164.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M166.94,163.48a2.17,2.17,0,1,1,4.33-.16h0v0a.21.21,0,0,1-.22.21h-3.67a1.75,1.75,0,0,0,1.74,1.71,1.68,1.68,0,0,0,1.44-.81.2.2,0,0,1,.29-.07.24.24,0,0,1,.08.31,2.16,2.16,0,0,1-1.81,1A2.2,2.2,0,0,1,166.94,163.48Zm.47-.35h3.39a1.71,1.71,0,0,0-3.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M175.25,163.48a2.17,2.17,0,1,1,4.33-.16h0v0a.21.21,0,0,1-.22.21h-3.67a1.75,1.75,0,0,0,1.73,1.71,1.69,1.69,0,0,0,1.45-.81.2.2,0,0,1,.29-.07.23.23,0,0,1,.07.31,2.13,2.13,0,0,1-1.81,1A2.2,2.2,0,0,1,175.25,163.48Zm.46-.35h3.4a1.73,1.73,0,0,0-1.69-1.46A1.76,1.76,0,0,0,175.71,163.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M184.33,163.06a1.38,1.38,0,0,0-1.38-1.38,1.4,1.4,0,0,0-1.39,1.38v2.47a.18.18,0,0,1,0,.1.19.19,0,0,1-.17.08h0a.23.23,0,0,1-.15-.12s0,0,0,0v-4.11a.22.22,0,0,1,.22-.22.21.21,0,0,1,.21.22v.43a1.84,1.84,0,0,1,1.39-.65,1.82,1.82,0,0,1,1.82,1.82v2.43a.22.22,0,0,1-.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M188.3,161.45a.24.24,0,0,1-.22.22h-.58v3.27a.35.35,0,0,0,.33.32.26.26,0,0,1,.23.23.25.25,0,0,1-.23.22.76.76,0,0,1-.78-.77v-3.27h-.56c-.22,0-.22-.11-.22-.22s0-.22.22-.22h.56v-1.66a.23.23,0,0,1,.45,0v1.66h.58A.24.24,0,0,1,188.3,161.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M189.71,163.48a2.17,2.17,0,1,1,4.33-.16h0v0a.21.21,0,0,1-.22.21h-3.67a1.75,1.75,0,0,0,1.73,1.71,1.69,1.69,0,0,0,1.45-.81.2.2,0,0,1,.29-.07.23.23,0,0,1,.07.31,2.13,2.13,0,0,1-1.81,1A2.2,2.2,0,0,1,189.71,163.48Zm.46-.35h3.4a1.73,1.73,0,0,0-1.69-1.46A1.76,1.76,0,0,0,190.17,163.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M195.4,161.46a.22.22,0,0,1,.23-.22.21.21,0,0,1,.21.22v1l.06-.11a2.18,2.18,0,0,1,1.8-1.1.22.22,0,0,1,.22.22.23.23,0,0,1-.22.22,1.62,1.62,0,0,0-1.3.73,4,4,0,0,0-.54,1,.15.15,0,0,0,0,.08v2a.21.21,0,0,1-.21.22.22.22,0,0,1-.23-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M203.72,161.45a.24.24,0,0,1-.22.22h-.58v3.27a.35.35,0,0,0,.33.32.26.26,0,0,1,.23.23.25.25,0,0,1-.23.22.76.76,0,0,1-.78-.77v-3.27h-.56c-.22,0-.22-.11-.22-.22s0-.22.22-.22h.56v-1.66a.23.23,0,0,1,.45,0v1.66h.58A.24.24,0,0,1,203.72,161.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M208.92,163a1.42,1.42,0,0,0-2.84,0v2.52s0,0,0,0l0,0a.18.18,0,0,1-.14.11h-.06a.21.21,0,0,1-.17-.07l0-.07a.22.22,0,0,1,0-.08v-6a.22.22,0,0,1,.22-.22.22.22,0,0,1,.23.22v2.36a1.86,1.86,0,0,1,1.41-.66,1.79,1.79,0,0,1,1.88,1.77v2.49a.22.22,0,0,1-.23.22.22.22,0,0,1-.22-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M210.91,163.48a2.17,2.17,0,0,1,4.34-.16h0v0a.21.21,0,0,1-.22.21h-3.68a1.77,1.77,0,0,0,1.74,1.71,1.68,1.68,0,0,0,1.44-.81.22.22,0,0,1,.3-.07.24.24,0,0,1,.07.31,2.14,2.14,0,0,1-1.81,1A2.2,2.2,0,0,1,210.91,163.48Zm.47-.35h3.39a1.73,1.73,0,0,0-1.68-1.46A1.75,1.75,0,0,0,211.38,163.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M222.45,159.22a3.25,3.25,0,1,1-3.09,3.25A3.16,3.16,0,0,1,222.45,159.22Zm0,6a2.79,2.79,0,1,0-2.64-2.79A2.71,2.71,0,0,0,222.45,165.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M228.56,159.76h-1.93a.23.23,0,0,1,0-.45h4.3a.22.22,0,0,1,.22.22.22.22,0,0,1-.22.23H229v5.73a.22.22,0,1,1-.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M232.83,159.53a.22.22,0,0,1,.22-.22h1.81a1.83,1.83,0,0,1,0,3.65l-1.58,0v2.51a.22.22,0,0,1-.23.22.22.22,0,0,1-.22-.22Zm2,3a1.4,1.4,0,0,0,1.38-1.39,1.38,1.38,0,0,0-1.38-1.38h-1.58v2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M240.48,163.46a2.26,2.26,0,0,1,2.3-2.23,2.32,2.32,0,0,1,1.43.5.21.21,0,0,1,0,.3.22.22,0,0,1-.3,0,1.89,1.89,0,0,0-1.16-.4,1.81,1.81,0,1,0,0,3.61,1.89,1.89,0,0,0,1.16-.39.23.23,0,0,1,.3,0,.22.22,0,0,1-.05.32,2.32,2.32,0,0,1-1.41.47A2.26,2.26,0,0,1,240.48,163.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M247.79,161.23a2.24,2.24,0,1,1-2.12,2.24A2.19,2.19,0,0,1,247.79,161.23Zm0,4a1.81,1.81,0,1,0-1.68-1.8A1.75,1.75,0,0,0,247.79,165.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M255.18,164.84a2.14,2.14,0,0,1-1.72.87,2.24,2.24,0,0,1,0-4.48,2.14,2.14,0,0,1,1.72.88v-2.58a.22.22,0,0,1,.23-.22.22.22,0,0,1,.22.22v6a.22.22,0,0,1-.22.22.22.22,0,0,1-.23-.22Zm0-1.28v-.15a1.72,1.72,0,1,0-1.72,1.85A1.75,1.75,0,0,0,255.18,163.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M257.17,163.48a2.17,2.17,0,1,1,4.33-.16h0v0a.21.21,0,0,1-.22.21h-3.67a1.76,1.76,0,0,0,1.74,1.71,1.68,1.68,0,0,0,1.44-.81.21.21,0,0,1,.29-.07.24.24,0,0,1,.08.31,2.14,2.14,0,0,1-1.81,1A2.2,2.2,0,0,1,257.17,163.48Zm.47-.35H261a1.73,1.73,0,0,0-1.68-1.46A1.75,1.75,0,0,0,257.64,163.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M265.49,164.78a.22.22,0,0,1,.31,0,2.37,2.37,0,0,0,1.37.52A1.37,1.37,0,0,0,268,165a.69.69,0,0,0,.34-.55.7.7,0,0,0-.32-.55,2.39,2.39,0,0,0-1-.33h0a2.5,2.5,0,0,1-1-.34.94.94,0,0,1-.49-.81,1.13,1.13,0,0,1,.49-.88,1.93,1.93,0,0,1,1.09-.3,2.42,2.42,0,0,1,1.34.49.23.23,0,0,1,.06.31.21.21,0,0,1-.3.06,2,2,0,0,0-1.1-.45,1.39,1.39,0,0,0-.85.26.68.68,0,0,0-.28.51.54.54,0,0,0,.25.45,2.24,2.24,0,0,0,.92.31h0a3.19,3.19,0,0,1,1.09.37,1.12,1.12,0,0,1,.5.91,1.15,1.15,0,0,1-.51.91,1.89,1.89,0,0,1-1.12.35,2.66,2.66,0,0,1-1.65-.64A.2.2,0,0,1,265.49,164.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M270,163.48a2.17,2.17,0,1,1,4.33-.16h0v0a.21.21,0,0,1-.22.21h-3.67a1.75,1.75,0,0,0,1.73,1.71,1.69,1.69,0,0,0,1.45-.81.2.2,0,0,1,.29-.07.23.23,0,0,1,.07.31,2.13,2.13,0,0,1-1.81,1A2.2,2.2,0,0,1,270,163.48Zm.46-.35h3.39a1.71,1.71,0,0,0-1.68-1.46A1.76,1.76,0,0,0,270.44,163.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M279.06,163.06a1.38,1.38,0,0,0-1.38-1.38,1.4,1.4,0,0,0-1.39,1.38v2.47a.3.3,0,0,1,0,.1.19.19,0,0,1-.17.08H276a.23.23,0,0,1-.15-.12s0,0,0,0v-4.11a.22.22,0,1,1,.43,0v.43a1.82,1.82,0,0,1,3.21,1.17v2.43a.22.22,0,0,1-.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M283,161.45a.24.24,0,0,1-.22.22h-.58v3.27a.35.35,0,0,0,.33.32.26.26,0,0,1,.23.23.25.25,0,0,1-.23.22.75.75,0,0,1-.78-.77v-3.27h-.56c-.22,0-.22-.11-.22-.22s0-.22.22-.22h.56v-1.66a.24.24,0,0,1,.22-.22.25.25,0,0,1,.23.22v1.66h.58A.24.24,0,0,1,283,161.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M289.43,161.45a.24.24,0,0,1-.22.22h-.58v3.27a.35.35,0,0,0,.33.32.26.26,0,0,1,.23.23.25.25,0,0,1-.23.22.76.76,0,0,1-.79-.77v-3.27h-.55c-.22,0-.22-.11-.22-.22s0-.22.22-.22h.55v-1.66a.24.24,0,0,1,.22-.22.25.25,0,0,1,.24.22v1.66h.58A.24.24,0,0,1,289.43,161.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M293.29,161.23a2.24,2.24,0,1,1-2.12,2.24A2.19,2.19,0,0,1,293.29,161.23Zm0,4a1.81,1.81,0,0,0,0-3.61,1.81,1.81,0,0,0,0,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M299.46,161.44a.21.21,0,0,1,.21-.21.22.22,0,0,1,.23.21v2.44a1.37,1.37,0,0,0,1.37,1.38,1.39,1.39,0,0,0,1.39-1.38v-2.44a.17.17,0,0,1,0-.11s0,0,0,0h0s0-.05.08-.06h.1l.11.05a.18.18,0,0,1,.05.07.19.19,0,0,1,0,.09v3.92a2.11,2.11,0,0,1-2.13,2.1,2.18,2.18,0,0,1-.92-.21A.22.22,0,0,1,300,167a.23.23,0,0,1,.28-.11,1.66,1.66,0,0,0,.73.17,1.68,1.68,0,0,0,1.69-1.66v-.3a1.82,1.82,0,0,1-3.2-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M306.85,161.23a2.24,2.24,0,1,1-2.12,2.24A2.19,2.19,0,0,1,306.85,161.23Zm0,4a1.81,1.81,0,1,0-1.68-1.8A1.75,1.75,0,0,0,306.85,165.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M310.41,161.44a.22.22,0,0,1,.44,0v2.44a1.38,1.38,0,1,0,2.76,0v-2.44a.23.23,0,0,1,.22-.22.22.22,0,0,1,.23.22v2.44a1.83,1.83,0,1,1-3.65,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M316.11,161.46a.22.22,0,0,1,.23-.22.21.21,0,0,1,.21.22v1a.3.3,0,0,1,.06-.11,2.16,2.16,0,0,1,1.79-1.1.22.22,0,0,1,.22.22.22.22,0,0,1-.22.22,1.63,1.63,0,0,0-1.3.73,4.31,4.31,0,0,0-.54,1,.28.28,0,0,0,0,.08v2a.21.21,0,0,1-.21.22.22.22,0,0,1-.23-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M326.06,163.06a1.38,1.38,0,0,0-1.38-1.38,1.4,1.4,0,0,0-1.39,1.38v2.47a.3.3,0,0,1,0,.1.19.19,0,0,1-.17.08H323a.23.23,0,0,1-.15-.12s0,0,0,0v-4.11a.22.22,0,1,1,.43,0v.43a1.82,1.82,0,0,1,3.21,1.17v2.43a.22.22,0,0,1-.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M328.37,161.44a.22.22,0,0,1,.44,0v2.44a1.38,1.38,0,1,0,2.76,0v-2.44a.23.23,0,0,1,.22-.22.22.22,0,0,1,.23.22v2.44a1.83,1.83,0,1,1-3.65,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M340.48,163.06a1.41,1.41,0,0,0-1.39-1.39,1.39,1.39,0,0,0-1.38,1.39v2.51a.32.32,0,0,1-.11.12l-.11,0h-.07l-.05,0,0,0,0,0v0s0,0,0,0h0a0,0,0,0,0,0,0v-2.49a1.38,1.38,0,1,0-2.76,0v2.44a.21.21,0,0,1-.1.18l-.06,0h-.09a.23.23,0,0,1-.18-.16v-4.1a.21.21,0,0,1,.21-.21.21.21,0,0,1,.22.21v.43a1.8,1.8,0,0,1,1.38-.64,1.83,1.83,0,0,1,1.6.95,1.86,1.86,0,0,1,1.61-.95,1.82,1.82,0,0,1,1.81,1.82v2.44a.21.21,0,0,1-.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M342.76,163.57v-4a.22.22,0,0,1,.22-.22.22.22,0,0,1,.23.22v2.58a2.13,2.13,0,0,1,1.72-.88,2.24,2.24,0,0,1,0,4.48,2.12,2.12,0,0,1-1.72-.87v.65a.22.22,0,0,1-.23.22.22.22,0,0,1-.22-.22Zm.45-.09a1.77,1.77,0,1,0,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M348.47,163.48a2.17,2.17,0,0,1,4.34-.16h0v0a.22.22,0,0,1-.22.21h-3.68a1.76,1.76,0,0,0,1.74,1.71,1.68,1.68,0,0,0,1.44-.81.21.21,0,0,1,.29-.07.23.23,0,0,1,.08.31,2.14,2.14,0,0,1-1.81,1A2.2,2.2,0,0,1,348.47,163.48Zm.47-.35h3.39a1.73,1.73,0,0,0-1.68-1.46A1.75,1.75,0,0,0,348.94,163.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354.17,161.46a.22.22,0,1,1,.44,0v1a.3.3,0,0,1,.06-.11,2.16,2.16,0,0,1,1.79-1.1.22.22,0,0,1,.22.22.22.22,0,0,1-.22.22,1.63,1.63,0,0,0-1.3.73,4.31,4.31,0,0,0-.54,1,.28.28,0,0,0,0,.08v2a.22.22,0,1,1-.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M205.18,141.44l-.13-.09s0,0,0,0a.44.44,0,0,1-.09-.11h0a.42.42,0,0,0-.09-.14l-4.32-10.31a1,1,0,0,1,1.78-.75l3.44,8.18,3.45-8.18a1,1,0,0,1,1.27-.51,1,1,0,0,1,.53,1.26L206.63,141a.7.7,0,0,1-.08.14h0s-.07.07-.09.11,0,0,0,0a.81.81,0,0,1-.1.09l0,0a.85.85,0,0,1-.14.09h0a.42.42,0,0,0-.15,0h0a.58.58,0,0,1-.18,0,.5.5,0,0,1-.17,0h0a.33.33,0,0,0-.14,0h0l-.15-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M212.35,137.2a4.37,4.37,0,0,1,4.31-4.41,4.22,4.22,0,0,1,4.25,4.1V137a.39.39,0,0,1,0,.15.84.84,0,0,1-.91.71h-5.62A2.39,2.39,0,0,0,215,139a2.74,2.74,0,0,0,1.7.79,2.93,2.93,0,0,0,1.83-.44,1,1,0,0,1,1.33-.05.8.8,0,0,1,0,1.14,4.45,4.45,0,0,1-3.16,1.17A4.39,4.39,0,0,1,212.35,137.2Zm1.92-.86h5a2.88,2.88,0,0,0-2.61-1.87A2.49,2.49,0,0,0,214.27,136.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M228.79,133.73a.94.94,0,0,1-.94.93,1.7,1.7,0,0,0-1.06.34,2.64,2.64,0,0,0-.81.85,5.43,5.43,0,0,0-.72,1.48v3.35a1,1,0,0,1-1,.94,1,1,0,0,1-.94-.94v-7a.93.93,0,0,1,.94-.92,1,1,0,0,1,1,.92v.12a2.44,2.44,0,0,1,.37-.35,3.83,3.83,0,0,1,2.22-.69A.92.92,0,0,1,228.79,133.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M233,130.59a1,1,0,0,1-.95,1,1,1,0,0,1-1-1v-.38a1,1,0,0,1,1-1,.94.94,0,0,1,.95,1Zm0,3.19v6.88a1,1,0,0,1-.95,1,1,1,0,0,1-1-1v-6.88a1,1,0,0,1,1-1A.94.94,0,0,1,233,133.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M239,132.21v.25h.53a1,1,0,0,1,1,1,1,1,0,0,1-1,1H239v6.23a1,1,0,0,1-1.94,0V134.4h-.46a1,1,0,0,1-1-1,1,1,0,0,1,1-1H237v-.25a3.6,3.6,0,0,1,.34-1.73,2.09,2.09,0,0,1,1.27-1.1,3.72,3.72,0,0,1,1.06-.14,1,1,0,0,1,0,2,1.13,1.13,0,0,0-.46.06.16.16,0,0,0-.11.05S239,131.56,239,132.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M244.38,130.59a1,1,0,0,1-.95,1,1,1,0,0,1-1-1v-.38a1,1,0,0,1,1-1,.94.94,0,0,1,.95,1Zm0,3.19v6.88a.94.94,0,0,1-.95,1,1,1,0,0,1-1-1v-6.88a.94.94,0,0,1,1-1A.93.93,0,0,1,244.38,133.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M246.8,137.22a4.5,4.5,0,0,1,4.49-4.43,4.63,4.63,0,0,1,2.8,1,1,1,0,0,1,.2,1.31,1,1,0,0,1-1.33.18,2.76,2.76,0,0,0-1.67-.57,2.54,2.54,0,1,0,0,5.07,2.8,2.8,0,0,0,1.67-.57.94.94,0,1,1,1.13,1.5,4.8,4.8,0,0,1-2.8.94A4.48,4.48,0,0,1,246.8,137.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M265,137.22v3.46a.94.94,0,0,1-.93.94,1,1,0,0,1-.92-.76,4,4,0,0,1-2.35.76,4.12,4.12,0,0,1-3-1.29,4.52,4.52,0,0,1-1.2-3.11,4.42,4.42,0,0,1,1.2-3.1,4,4,0,0,1,5.35-.55,1,1,0,0,1,.92-.78,1,1,0,0,1,.93,1Zm-1.87,0a2.59,2.59,0,0,0-.69-1.82,2.19,2.19,0,0,0-1.64-.72,2.16,2.16,0,0,0-1.64.72,2.62,2.62,0,0,0-.67,1.82,2.66,2.66,0,0,0,.67,1.82,2.24,2.24,0,0,0,1.64.69,2.27,2.27,0,0,0,1.64-.69A2.63,2.63,0,0,0,263.1,137.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M272.41,133.76a1,1,0,0,1-1,1H271v4.93a1,1,0,0,1,1,1,1,1,0,0,1-1,1,2,2,0,0,1-2-2v-4.93h-.51a1,1,0,0,1,0-1.94H269v-2.56a1,1,0,0,1,1-1,1,1,0,0,1,1,1v2.56h.44A1,1,0,0,1,272.41,133.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M277.42,130.59a1,1,0,0,1-.95,1,1,1,0,0,1-1-1v-.38a1,1,0,0,1,1-1,.94.94,0,0,1,.95,1Zm0,3.19v6.88a.94.94,0,0,1-.95,1,1,1,0,0,1-1-1v-6.88a.94.94,0,0,1,1-1A.93.93,0,0,1,277.42,133.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M281.27,140.33a4.45,4.45,0,0,1-1.21-3.11,4.6,4.6,0,0,1,1.21-3.09,4.13,4.13,0,0,1,3-1.34,3.91,3.91,0,0,1,2.95,1.34,4.43,4.43,0,0,1,1.23,3.09,4.29,4.29,0,0,1-1.23,3.11,3.91,3.91,0,0,1-2.95,1.34A4.13,4.13,0,0,1,281.27,140.33Zm.71-3.11a2.82,2.82,0,0,0,.64,1.87,2.36,2.36,0,0,0,1.69.66,2.28,2.28,0,0,0,1.62-.66,2.66,2.66,0,0,0,.69-1.87,2.6,2.6,0,0,0-.69-1.83,2.47,2.47,0,0,0-1.62-.67,2.54,2.54,0,0,0-1.69.67A2.75,2.75,0,0,0,282,137.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M298.86,136.46v4.22a.93.93,0,0,1-.92.94,1,1,0,0,1-.93-.94v-4.22a1.81,1.81,0,0,0-1.84-1.78,1.75,1.75,0,0,0-1.76,1.78v4.22a.33.33,0,0,1,0,.18,1,1,0,0,1-.93.76.94.94,0,0,1-.94-.94v-7a.94.94,0,0,1,1.8-.39,3.48,3.48,0,0,1,1.87-.55A3.7,3.7,0,0,1,298.86,136.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M479.23,77.25s-6.57,52.61-17.37,64.44c-13,14.2-22.37,12.12-27.6,19.45a0,0,0,0,0,0,0c-5.24-7.34-14.64-5.25-27.62-19.46-10.8-11.83-17.35-64.44-17.35-64.44,28.45-13.81,45-29.29,45-29.29h0C434.77,48.45,451.22,63.66,479.23,77.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M434.26,48V161.14a0,0,0,0,0,0,0c-5.24-7.34-14.64-5.25-27.62-19.46-10.8-11.83-17.35-64.44-17.35-64.44,28.45-13.81,45-29.29,45-29.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M396.26,81.49s5.54,44.44,14.66,54.44c11,12,18.92,10.25,23.34,16.43,4.42-6.18,12.37-4.42,23.33-16.43,9.12-10,14.66-54.44,14.66-54.44-24-11.67-38-24.75-38-24.75S420.29,69.82,396.26,81.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.2
    },
    d: "M472.24,81.49s-5.55,44.43-14.67,54.44c-10.95,12-18.9,10.25-23.32,16.42V56.76C434.67,57.16,448.58,70,472.24,81.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#455a64"
    },
    r: 17.62,
    cy: 104.55,
    cx: 434.25
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "432.25 116 424.4 107.84 427.31 105.04 431.64 109.54 440.96 95.23 444.35 97.44 432.25 116"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d2232a"
    },
    points: "472.24 153.41 469.75 153.88 469.19 156.5 468.63 153.88 466.14 153.41 468.62 152.81 469.19 150.33 469.76 152.81 472.24 153.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d2232a"
    },
    points: "398.43 133.44 395.94 133.9 395.38 136.53 394.82 133.9 392.33 133.44 394.81 132.83 395.38 130.35 395.95 132.83 398.43 133.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d2232a"
    },
    points: "409.8 64.2 407.31 64.66 406.75 67.28 406.2 64.66 403.7 64.19 406.19 63.59 406.75 61.11 407.32 63.59 409.8 64.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d2232a"
    },
    points: "467.78 141.6 466.39 141.86 466.08 143.33 465.77 141.86 464.37 141.6 465.76 141.26 466.08 139.87 466.39 141.26 467.78 141.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d2232a"
    },
    points: "477.41 112.37 476.02 112.63 475.71 114.1 475.4 112.63 474 112.37 475.39 112.03 475.71 110.65 476.03 112.03 477.41 112.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d2232a"
    },
    points: "465.59 61.11 464.2 61.37 463.89 62.83 463.57 61.37 462.18 61.11 463.57 60.77 463.89 59.38 464.2 60.77 465.59 61.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d2232a"
    },
    points: "430.02 167.46 428.63 167.72 428.31 169.18 428 167.72 426.61 167.46 428 167.12 428.31 165.73 428.63 167.12 430.02 167.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d2232a"
    },
    points: "390.69 136.86 389.3 137.12 388.98 138.59 388.67 137.12 387.28 136.86 388.67 136.52 388.98 135.13 389.3 136.52 390.69 136.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d2232a"
    },
    points: "392.86 96.16 391.46 96.42 391.15 97.89 390.84 96.42 389.45 96.16 390.83 95.82 391.15 94.43 391.47 95.82 392.86 96.16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M451.28,148.19a.41.41,0,0,0,0,.81A.41.41,0,0,0,451.28,148.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M387.08,75a.41.41,0,0,0,0,.81A.41.41,0,0,0,387.08,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M463.89,150.46a.41.41,0,0,0,0,.81A.41.41,0,0,0,463.89,150.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M423,87.41a.4.4,0,0,0,0,.8A.4.4,0,0,0,423,87.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M385.62,103.67a.41.41,0,0,0,0,.81A.41.41,0,0,0,385.62,103.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M376.21,99.27a.29.29,0,0,0,0,.57A.29.29,0,0,0,376.21,99.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M453.24,55.84a.29.29,0,0,0,0,.57A.29.29,0,0,0,453.24,55.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M413.38,153.61a.29.29,0,0,0,0,.57A.29.29,0,0,0,413.38,153.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M404.45,148.36a.78.78,0,0,0,0,1.55A.78.78,0,0,0,404.45,148.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "212.21 216.01 212.21 232.83 216.64 232.83 216.64 240.5 224.31 232.83 276.38 232.83 276.38 216.01 212.21 216.01"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M212.21,216c0,5.67.2,11.28.21,16.82l-.21-.21h4.65v.22l0,7.67-.42-.18,7.64-7.68.08-.08h.12l26-.06,26,0-.36.36,0-16.82.32.31-32-.11Zm0,0,32-.2,32.17-.11h.31V216l.05,16.82v.36h-.36l-26,0-26-.06.19-.08-7.69,7.65-.41.41v-.58l0-7.67.22.22H212v-.21C212,227.16,212.17,221.55,212.21,216Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M223.43,222.09v2.26h-.64v-2.26a1.46,1.46,0,1,0-2.91,0v2.26h-.64v-2.26a2.1,2.1,0,1,1,4.19,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "219.25 222.68 219.88 222.71 219.88 224.35 219.25 224.35 219.25 222.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "223.43 222.85 223.43 224.35 222.79 224.35 222.79 222.82 223.43 222.85"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#263238"
    },
    height: 4.83,
    width: 5.81,
    y: 223.52,
    x: 218.43
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M233.52,222.43A8.21,8.21,0,0,1,232,224.5,8.09,8.09,0,0,1,229.9,226a8,8,0,0,1,1.55-2.07A7.76,7.76,0,0,1,233.52,222.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M229.9,222.43A7.81,7.81,0,0,1,232,224a8.21,8.21,0,0,1,1.54,2.07,7.87,7.87,0,0,1-2.07-1.54A8,8,0,0,1,229.9,222.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M234.26,224.23a8.05,8.05,0,0,1-2.55.38,7.78,7.78,0,0,1-2.55-.38,7.76,7.76,0,0,1,2.55-.37A8,8,0,0,1,234.26,224.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M231.71,221.68a8.75,8.75,0,0,1,0,5.1,7.76,7.76,0,0,1-.37-2.55A8,8,0,0,1,231.71,221.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M242.32,222.43a7.76,7.76,0,0,1-1.54,2.07,8,8,0,0,1-2.07,1.54,8.21,8.21,0,0,1,1.54-2.07A7.76,7.76,0,0,1,242.32,222.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M238.71,222.43a8.88,8.88,0,0,1,3.61,3.61,8.88,8.88,0,0,1-3.61-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M243.07,224.23a8.05,8.05,0,0,1-2.55.38,7.78,7.78,0,0,1-2.55-.38,7.76,7.76,0,0,1,2.55-.37A8,8,0,0,1,243.07,224.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M240.52,221.68a8,8,0,0,1,.37,2.55,7.76,7.76,0,0,1-.37,2.55,7.78,7.78,0,0,1-.38-2.55A8.05,8.05,0,0,1,240.52,221.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M251.13,222.43a7.76,7.76,0,0,1-1.54,2.07,8.21,8.21,0,0,1-2.07,1.54,8,8,0,0,1,1.54-2.07A7.76,7.76,0,0,1,251.13,222.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M247.52,222.43a8.88,8.88,0,0,1,3.61,3.61,8.88,8.88,0,0,1-3.61-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M251.88,224.23a8.05,8.05,0,0,1-2.55.38,7.87,7.87,0,0,1-2.56-.38,7.86,7.86,0,0,1,2.56-.37A8,8,0,0,1,251.88,224.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M249.33,221.68a9,9,0,0,1,0,5.1,8.75,8.75,0,0,1,0-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M259.94,222.43a8,8,0,0,1-1.54,2.07,8.21,8.21,0,0,1-2.07,1.54,8,8,0,0,1,1.54-2.07A7.76,7.76,0,0,1,259.94,222.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M256.33,222.43a8.88,8.88,0,0,1,3.61,3.61,8.21,8.21,0,0,1-2.07-1.54A8,8,0,0,1,256.33,222.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M260.69,224.23a8.05,8.05,0,0,1-2.55.38,7.84,7.84,0,0,1-2.56-.38,7.82,7.82,0,0,1,2.56-.37A8,8,0,0,1,260.69,224.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M258.14,221.68a9,9,0,0,1,0,5.1,8.75,8.75,0,0,1,0-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M268.75,222.43a8,8,0,0,1-1.54,2.07,8.21,8.21,0,0,1-2.07,1.54,8,8,0,0,1,1.54-2.07A7.76,7.76,0,0,1,268.75,222.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M265.14,222.43a7.76,7.76,0,0,1,2.07,1.54,8,8,0,0,1,1.54,2.07,8.21,8.21,0,0,1-2.07-1.54A8,8,0,0,1,265.14,222.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M269.5,224.23a8.07,8.07,0,0,1-2.56.38,7.78,7.78,0,0,1-2.55-.38,7.76,7.76,0,0,1,2.55-.37A8.06,8.06,0,0,1,269.5,224.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M266.94,221.68a8.75,8.75,0,0,1,0,5.1,9,9,0,0,1,0-5.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#c7c7c7"
    },
    points: "141.91 419.16 84.16 465.72 87.42 465.72 154.11 419.16 141.91 419.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#c7c7c7"
    },
    points: "147.33 419.16 118.8 465.72 122.05 465.72 157.03 419.16 147.33 419.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#c7c7c7"
    },
    points: "161.32 419.16 189.85 465.72 186.6 465.72 151.63 419.16 161.32 419.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#c7c7c7"
    },
    points: "166.31 419.16 224.05 465.72 220.8 465.72 154.11 419.16 166.31 419.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455a64"
    },
    points: "262.68 402.08 262.68 388.46 183.39 385.21 141.5 273.38 45.53 273.38 79.49 402.08 160.61 424.86 165.7 424.86 262.68 402.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1
    },
    points: "45.53 273.38 56.51 273.38 91.89 390.7 163.66 411.03 262.68 388.46 262.68 402.08 165.7 424.86 160.61 424.86 79.49 402.08 45.53 273.38"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M219.51,486.9c-2.42-.93-56.85-45.52-57.85-48.53-.39-1.14,5.64-9.45,13.22-19.28,1.63-2.12,3.34-4.3,5.08-6.51,11.28-14.34,23.59-29.29,23.59-29.29L240.05,413l-24.6,28.47-5.4,6.25s13.21,26.4,13.95,29.82S221.93,487.82,219.51,486.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M219.51,486.9c-2.42-.93-56.85-45.52-57.85-48.53-.47-1.4,8.54-13.37,18.3-25.79l35.49,28.91-5.4,6.25s13.21,26.4,13.95,29.82S221.93,487.82,219.51,486.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M219.51,486.9c-2.42-.93-56.85-45.52-57.85-48.53-.39-1.14,5.64-9.45,13.22-19.28l35.17,28.65s13.21,26.4,13.95,29.82S221.93,487.82,219.51,486.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M220.52,484.08c-9-7.7-45.73-37.91-55.16-44.84-.07-.06-.11,0,0,.05C174,447.12,211,477,220.39,484.23,220.59,484.38,220.7,484.24,220.52,484.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M222.1,472.73a9.47,9.47,0,0,0-7.28-2.24,9.16,9.16,0,0,0-6,3.2c0,.05.06.14.11.09a10.93,10.93,0,0,1,13.11-.93A.07.07,0,1,0,222.1,472.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M212.85,451.55c-3.61-3.05-8.9-5.23-13.62-4.1-.18.05-.11.3,0,.34a64.57,64.57,0,0,1,13.27,4.26A.3.3,0,0,0,212.85,451.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M214.77,455c-3.61-3-8.9-5.23-13.62-4.1-.18,0-.12.3,0,.34a64.76,64.76,0,0,1,13.27,4.26A.3.3,0,0,0,214.77,455Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M216.69,458.37c-3.61-3.05-8.9-5.23-13.62-4.1-.18,0-.12.3,0,.34a64.76,64.76,0,0,1,13.27,4.26A.3.3,0,0,0,216.69,458.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M218.61,461.77c-3.61-3-8.9-5.22-13.62-4.09-.18,0-.12.3,0,.33a65.41,65.41,0,0,1,13.27,4.27A.3.3,0,0,0,218.61,461.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M174.79,432.47c-4.11-3.34-9.31,3-5.2,6.39S178.9,435.82,174.79,432.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M224.78,445c-.59-3.05-4.15-3.46-6.59-2.8a24.71,24.71,0,0,0-11,6.62.11.11,0,0,0,0,.19.58.58,0,0,0,.41.84c4.08.33,8.39,1.19,12.44.26C222.47,449.61,225.34,447.92,224.78,445Zm-10.84,4.09c-2-.12-4-.33-6-.37a74.6,74.6,0,0,1,6.49-3.73,27.2,27.2,0,0,1,3.36-1.37c1.78-.55,7.86-.67,5,3.6C221.16,449.62,216.33,449.26,213.94,449.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M197,442.78c2.78,3.09,6.8,4.87,10.32,7a.58.58,0,0,0,.82-.44c.08,0,.15-.05.13-.15a24.7,24.7,0,0,0-5.15-11.73c-1.62-2-4.76-3.66-7-1.51S195.41,441,197,442.78Zm-.51-3.89c.1-5.16,5-1.56,6.14-.08a27.89,27.89,0,0,1,2,3.06c1.24,2.18,2.14,4.49,3.16,6.78-1.67-1.13-3.42-2.1-5.13-3.16C200.63,444.22,196.48,441.73,196.53,438.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M278,357.17c-2.76,19.12-50.61,73.82-56.14,80.09-.82.92-1.26,1.43-1.26,1.43l-38.67-30.47.46-.58,34.92-44.58-102.52-1.85,39.3-29.8s3.13,1.86,9.71,1c22.66-3,73.76-9.75,85.79-9.12C265.05,324.11,280.48,339.63,278,357.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M229.8,346.48a46.07,46.07,0,0,0-3.6,4.5c-1.23,1.58-2.49,3.14-3.72,4.72l0,.05c.22-.47.43-.93.66-1.39.79-1.58,1.42-3.21,2.34-4.72a.08.08,0,0,0-.14-.09c-.95,1.5-2,2.92-2.86,4.49-.38.74-.75,1.49-1.09,2.25-.18.42-.37.84-.54,1.27a4,4,0,0,0-.23.61c-.56.73-1.1,1.47-1.63,2.22-1.18,1.66-2.22,3.42-3.42,5.07-.06.08.08.17.15.09,1.2-1.55,2.55-3,3.77-4.53s2.43-3.18,3.6-4.8,2.26-3.18,3.4-4.77a47.27,47.27,0,0,0,3.44-4.89A.07.07,0,0,0,229.8,346.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M225.88,429.71c-2.2-1.92-4.56-3.69-6.88-5.47s-4.66-3.57-7-5.33c-4.69-3.53-9.37-7.09-14.11-10.55-2.6-1.91-5.22-3.78-7.93-5.55-.12-.07-.25.12-.14.21,4.46,3.81,9.2,7.28,13.88,10.8s9.41,7,14.16,10.5c2.6,1.89,5.19,3.84,7.9,5.57C225.87,430,226,429.79,225.88,429.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M142.66,280.92c10.64,20.25,23.26,41.74,35.22,44.85,11.37,3,38.44-25.38,43-34.8,1.59-3.24-19.84-17.45-22.88-15.07-5.71,4.51-18.23,18.77-20,18.41s-17-13.88-30.67-25.25C139,262.17,135.3,266.89,142.66,280.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6"
    },
    d: "M201.9,243l-8.19,28.67a1,1,0,0,0,.9,1.57l14.91.47a2.42,2.42,0,0,0,2.12-1.48l8.19-28.67c.34-.84-.07-1.54-.9-1.56L204,241.54A2.41,2.41,0,0,0,201.9,243Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb"
    },
    d: "M203.67,243.05l-8.19,28.67c-.33.84.07,1.54.9,1.57l14.92.47a2.42,2.42,0,0,0,2.11-1.48l8.19-28.67c.34-.84-.07-1.54-.9-1.56l-14.91-.47A2.42,2.42,0,0,0,203.67,243.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M207.72,244.5a1.27,1.27,0,1,1-2.53-.14,1.27,1.27,0,1,1,2.53.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M227.81,274.74c1.26-8.33.3-10.66,5.1-17.13,3.15-4.25,1.79-8.08-3.16-5.7-8.1,3.91-12,14.32-12.29,18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M217.06,296.58s7.78-9.08,10-17.83c1.53-6.05,3.4-19.58-9.82-32.7-3.14-3.11-9.81-5.32-6.54,1.62,2.33,4.93,5.3,7.36,6.13,10.47,0,0-8.83-1.8-11.82,1.46a81.72,81.72,0,0,0-7.22,9.09,17.53,17.53,0,0,0,1.58,1.5s-2.51,3.32-2,9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M227.6,272.75c-1.48-2.92-4.72-9.05-9.11-13.15-4.88-4.54-15.51-12-18.83-8.35-2.43,2.67,1.38,5.86,1.38,5.86s-5-2.15-6.72.74c-1.52,2.64,1.57,4.93,1.57,4.93s-3.28-.77-4.26,2.05c-1.18,3.39,5.9,4.46,7.67,8.93C199.7,274.76,227.6,272.75,227.6,272.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M214.54,265.56a26.55,26.55,0,0,0-13.37-8.49c-.14,0-.23.06-.12.11a64.92,64.92,0,0,1,13.45,8.43S214.56,265.59,214.54,265.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M209.81,270.35c-1.81-2-7.85-6.53-13.86-7.67-.13,0-.22.06-.1.11a70.71,70.71,0,0,1,13.92,7.61S209.83,270.38,209.81,270.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M190.65,279.59,213,303.26s-23.57,26.43-34.64,23.67-32-32.73-38.71-51.75C135,262,142.3,264.13,150,270.58s27.8,22.47,28.68,22.24S190.65,279.59,190.65,279.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M183.09,326.69a9.44,9.44,0,0,1-4.76.24c-11.07-2.76-32-32.72-38.71-51.75-3.06-8.67-.92-10.71,3.1-9.23C154.78,283.84,170.83,307.82,183.09,326.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M205.73,307.2c-3.23-3.27-16-17.11-18.52-20.28-.18-.22-.08-.39.13-.18,9.92,9.55,15.51,17,18.52,20.33C205.93,307.15,205.81,307.28,205.73,307.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M167.49,345S94.2,358.4,93.82,358s8.07-79.67,32.94-93.07c4-2.12,13.47-3.37,17.53.77C155.87,277.48,168.45,343.93,167.49,345Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M166.72,338.43,94.55,350.81c.27-2.18.63-4.78,1.08-7.71l69.76-12C165.93,333.9,166.37,336.37,166.72,338.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M164.62,327.27,96.28,339c.21-1.3.44-2.63.69-4l66.86-11.47C164.11,324.79,164.37,326.05,164.62,327.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M141.05,277.73c-4.09,0-9.3-7.54-10.76-13-.1-.37,1.24-3.71,2.68-7.85.86-2.51,1.76-5.33,2.39-8l15.54,8a43.14,43.14,0,0,0-4,9.72,5.47,5.47,0,0,0-.15,1.11c0,.05,0,.11,0,.18C146.54,270.09,145,277.74,141.05,277.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M150.91,257a43,43,0,0,0-4,9.72,5.47,5.47,0,0,0-.15,1.11,1.11,1.11,0,0,1,0,.17,8.82,8.82,0,0,1-1.72-.31c-9.55-2.54-9.39-15.09-9.16-18.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M134.7,230.83c-2.49,5.78-1.24,23.42,2.59,27.75,5.56,6.27,15.61,7.91,21.17,1,5.4-6.68,3.36-29.64-1-33.67C151,220,138.37,222.28,134.7,230.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M150.79,243.52c0-.05-.08.06-.08.11.15,1.18.12,2.55-.91,3,0,0,0,.08,0,.07C151.1,246.43,151.12,244.61,150.79,243.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M149.63,242.39c-1.91,0-1.71,3.84.06,3.81S151.23,242.36,149.63,242.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.73,243.14s.1.05.1.1c0,1.18.25,2.53,1.34,2.87,0,0,0,.07,0,.07C157.85,246.06,157.57,244.26,157.73,243.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M158.72,241.85c1.89-.24,2.24,3.56.49,3.78S157.14,242.06,158.72,241.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M148,240.72a15.25,15.25,0,0,0,1.45-.6,2.44,2.44,0,0,0,1.36-.89.8.8,0,0,0-.18-1,2,2,0,0,0-2-.1,2.93,2.93,0,0,0-1.63,1.36A.86.86,0,0,0,148,240.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M160.09,239.85c-.53-.06-1-.2-1.53-.31a2.58,2.58,0,0,1-1.51-.62.8.8,0,0,1,0-1,2,2,0,0,1,2-.49,3,3,0,0,1,1.85,1A.86.86,0,0,1,160.09,239.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M150.1,254c.24.32.46.73.88.83a3.17,3.17,0,0,0,1.3-.11,0,0,0,0,1,.05.06,1.6,1.6,0,0,1-1.58.43,1.25,1.25,0,0,1-.77-1.17C150,254,150.06,254,150.1,254Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M151.4,250.55a4,4,0,0,0,2.78,1.64,5,5,0,0,0,1.45,0,3.1,3.1,0,0,0,.53-.1.29.29,0,0,0,.23-.27h0s-.21-2.52-.21-2.52c.34.15,2.07.82,2,.34a60.35,60.35,0,0,0-2.2-12.09.11.11,0,0,0-.22.05c.28,3.78,1.22,7.49,1.56,11.29a7.16,7.16,0,0,0-1.93-.48c-.07,0,.34,3.09.33,3.12a5.6,5.6,0,0,1-4.23-1.08C151.42,250.37,151.33,250.46,151.4,250.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M155.25,252a4.93,4.93,0,0,1-2,1.56,2.23,2.23,0,0,1-1.38.09c-1-.25-1-1.16-.84-1.94a5.6,5.6,0,0,1,.44-1.2A6.55,6.55,0,0,0,155.25,252Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9cbd"
    },
    d: "M153.25,253.57a2.23,2.23,0,0,1-1.38.09c-1-.25-1-1.16-.84-1.94A2.33,2.33,0,0,1,153.25,253.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M133.07,246.76c4.6.36,7-5.11,6-9.53,0,0,12.21,1.71,12.87-8.1a11.15,11.15,0,0,0,8.45,4.64l.81,3.45c1.26-.35,2.62-3.91-.43-6.73,0,0-.17-4.89-3.76-7.86a6.7,6.7,0,0,0-7.19-1.06,10.13,10.13,0,0,0-7.36-1.87,8.6,8.6,0,0,0-6.39,4.64s-6.07,1.11-7.13,5.41a8.9,8.9,0,0,0,1.14,7.2s-1.54,1.68-.79,5.36C129.77,244.67,131.69,246.65,133.07,246.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M151.68,228.25a12,12,0,0,1,0,2.4,10.15,10.15,0,0,1-.46,2.32,6.22,6.22,0,0,1-2.86,3.5,10,10,0,0,1-4.52,1.1c-.79,0-1.59,0-2.39-.08s-1.59-.19-2.39-.26c.78.19,1.57.36,2.36.54s1.61.15,2.42.23a9.81,9.81,0,0,0,4.8-1,6.49,6.49,0,0,0,3-3.86A9.84,9.84,0,0,0,151.68,228.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.94,234a12.57,12.57,0,0,1-3.69-2,7.88,7.88,0,0,1-1.43-1.51,9.48,9.48,0,0,1-1-1.86,5.14,5.14,0,0,0,.65,2.1,5.58,5.58,0,0,0,1.43,1.71,7.17,7.17,0,0,0,1.91,1.11A6.63,6.63,0,0,0,157.94,234Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M148.47,249.48a5.14,5.14,0,1,1,5.29-6.16h0a5.16,5.16,0,0,1-4,6.06A5.07,5.07,0,0,1,148.47,249.48Zm.47-9.59a4.17,4.17,0,0,0-1.11.09,4.44,4.44,0,1,0,1.11-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M160.24,248.61c-2-.1-3.65-2.2-3.83-4.87a6,6,0,0,1,.84-3.66,3.21,3.21,0,0,1,5.47-.38,6.24,6.24,0,0,1,1.33,3.51c.19,2.83-1.37,5.25-3.47,5.4Zm-.06-9.58h-.26a2.75,2.75,0,0,0-2.09,1.41,5.45,5.45,0,0,0-.74,3.25c.17,2.45,1.71,4.35,3.44,4.23s3-2.21,2.83-4.66a5.46,5.46,0,0,0-1.17-3.12A2.82,2.82,0,0,0,160.18,239Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M153.63,243.92l-.48-.49c.73-.71,2.47-1.71,3.82-.46l-.47.5C155.3,242.35,153.7,243.86,153.63,243.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M131.88,246.93l-.63-.28c.13-.29,1.29-2.88,2.81-3.24s9.64-.21,10-.2v.69a92,92,0,0,0-9.87.18C133.21,244.32,132.19,246.21,131.88,246.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M137.41,246.45s-3.41-6-6.08-4.79-.45,9.56,2.43,10.94a3,3,0,0,0,4.21-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M132,244.05s-.06.06,0,.08c2,1,2.94,3.07,3.53,5.15a1.67,1.67,0,0,0-2.46-.68.07.07,0,0,0,0,.12,1.88,1.88,0,0,1,2,.83,9.48,9.48,0,0,1,.84,1.76c.08.19.42.12.37-.1v-.05C136.6,248.5,134.86,244.58,132,244.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M146.94,269.83a0,0,0,0,0-.05,0c-.17,3.34-.78,11-6.15,10a11.7,11.7,0,0,1-5.52-3.4,41.92,41.92,0,0,1-7.17-10.3c-.05-.09-.17,0-.14.08a26.08,26.08,0,0,0,2.61,5.57,25.77,25.77,0,0,0,4.4,5.49c1.63,1.5,3.6,3,5.9,3.38a4.4,4.4,0,0,0,4.81-2.67A17.8,17.8,0,0,0,146.94,269.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M118.54,271.22c-11.44,10-40.77,49.5-33.57,57.95s52.47,2.59,65.48-2.08c3.88-1.39-7.86-25.84-12.14-26.81-3.58-.82-22.91,5.79-23.34,4.67s3.34-9.84,9.4-25.46C131.36,261.49,123.6,266.79,118.54,271.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M157.41,294.68c9.11-.35,11.5,1,19-3.42,4.94-2.87,8.9-.95,5.74,4.09-5.17,8.23-16.83,11.15-21.16,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M132.69,300.93S143.34,296.34,153,295c6.69-.92,21.46-1.31,34,14.48,3,3.75,4.54,11.19-2.53,6.83-5-3.09-7.27-6.57-10.52-7.84,0,0,.88,9.7-3,12.53a89.14,89.14,0,0,1-10.64,6.67,19,19,0,0,1-1.42-1.88s-3.86,2.3-10.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M159.53,295.15c3,1.94,9.16,6.16,13,11.37,4.3,5.79,11,18.11,6.72,21.24-3.16,2.3-6.14-2.18-6.14-2.18s1.7,5.67-1.61,7.12c-3,1.32-5.11-2.28-5.11-2.28s.45,3.62-2.7,4.34c-3.79.86-4.09-6.87-8.68-9.32C154,324.89,159.53,295.15,159.53,295.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M165.68,310a28.76,28.76,0,0,1,7.52,15.4c0,.15-.09.24-.13.11a71.28,71.28,0,0,0-7.44-15.47S165.66,310,165.68,310Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M160,314.56c1.94,2.18,6.08,9.21,6.59,15.81,0,.15-.1.24-.14.1a76.45,76.45,0,0,0-6.5-15.88S159.94,314.53,160,314.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M173.94,308.42c2.84,1.16,4.6,2.78,6.9,4.75a39.36,39.36,0,0,0,3.53,2.76c1.13.77,2.79,1.92,4.16,1a2.44,2.44,0,0,0,.78-2.34,11.92,11.92,0,0,0-1.28-3.49s.05-.08.07,0a16.63,16.63,0,0,1,1.47,3.14,4,4,0,0,1,0,2.31c-.59,1.57-2.52,1.59-3.82,1a12.59,12.59,0,0,1-2.19-1.34c-.67-.48-1.32-1-2-1.52-1.3-1.08-2.53-2.23-3.81-3.33a37,37,0,0,0-4-2.85A.06.06,0,0,1,173.94,308.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M179,319.34a91.19,91.19,0,0,0-5.16-10.85,0,0,0,0,1,.07-.06,48.48,48.48,0,0,1,5.82,10.43,16.26,16.26,0,0,1,1.2,6.36c-.31,3.06-2.39,3.43-3.16,3.51a4,4,0,0,1-2.56-.69,7.83,7.83,0,0,1-2.13-2.45s0-.1.06-.06c.94,1.31,2.58,2.68,4.27,2.63a2.79,2.79,0,0,0,2-.83,3.59,3.59,0,0,0,.73-2.42A16.42,16.42,0,0,0,179,319.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M132.69,300.93l11.16,31.21S87.23,339,83.42,328.9s21.48-45.69,32.27-55.7c12.51-11.61,13.51-7.13,9.9,3.9-3.77,11.56-10.49,28.14-10.49,28.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M97.48,311.48a66.12,66.12,0,0,1,8.55-3.93A62.86,62.86,0,0,1,115,305c1.73-.39,3.47-.69,5.22-1,0,0,.06.07,0,.08a80.18,80.18,0,0,0-9,2.51q-4.43,1.45-8.77,3.07c-1.65.62-3.26,1.3-4.88,2A.07.07,0,0,1,97.48,311.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M132.55,300.83c-.29.05-15.93,3.53-16.45,3.71.08-.22,3.61-8,4.13-9.14l.15-.34c.33-.5.66-1,1-1.51s.79-1.31,1.18-2c0,0,0,0,0,0l-1.26,1.91c-.19.3-.38.6-.56.91.35-.81.69-1.62,1-2.43.54-1.3,1-2.61,1.54-3.92a0,0,0,0,0-.07,0c-1,2.27-2.15,4.5-3.19,6.77s-5,10.59-5,10.59,17.27-4.21,17.61-4.32A.11.11,0,0,0,132.55,300.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M131.62,320.36c-1.23-3.48-2.42-7-3.78-10.41-.77-1.95-1.53-3.9-2.31-5.85,0-.07-.16,0-.14,0,1.09,3.54,2.19,7.09,3.45,10.58s2.46,7,3.75,10.42q1.11,2.94,2.38,5.82s.08,0,.07,0C134.07,327.36,132.85,323.87,131.62,320.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M144.52,332.67c-.46-1-1-2.36-1.53-3.31-.13-.26-.32-.22-.22,0,.34.87.59,1.84.93,2.74-.8.07-1.59.13-2.38.22l-2.75.29q-2.7.28-5.4.51-5.46.45-10.94.67a209.49,209.49,0,0,1-22-.14c-2-.13-4.09-.3-6.13-.53s-4.3-.51-6-.89c-.05,0-.07.07,0,.09a34,34,0,0,0,5.17,1.21c1.84.27,3.68.5,5.53.66,3.69.33,7.39.46,11.09.49q11,.09,22-.74c2.05-.15,4.09-.33,6.14-.53l3.09-.33C142.14,333,144.6,332.84,144.52,332.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c7c7c7"
    },
    height: 3.19,
    width: 71.29,
    y: 331.98,
    x: 146.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#a6a6a6"
    },
    points: "217.47 331.98 217.47 335.17 169.01 335.17 171.45 331.98 217.47 331.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#a6a6a6"
    },
    points: "178.81 335.17 241.2 335.17 250.23 291.15 187.84 291.15 178.81 335.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#c7c7c7"
    },
    points: "181.73 335.17 244.12 335.17 253.15 291.15 190.76 291.15 181.73 335.17"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M223.06,311.52A4.37,4.37,0,0,1,220,316c-1.78.38-3.27-1-3.34-3.09a4.4,4.4,0,0,1,3.11-4.44C221.5,308.06,223,309.45,223.06,311.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad6359"
    },
    d: "M362.76,426.55c-.93,2.42-45.7,56.7-48.72,57.7-1.14.38-9.43-5.68-19.23-13.29-2.12-1.64-4.3-3.35-6.5-5.1-14.3-11.33-29.21-23.68-29.21-23.68L289,405.78l28.38,24.68,6.24,5.42S350,422.76,353.43,422,363.69,424.13,362.76,426.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M362.76,426.55c-.93,2.42-45.7,56.7-48.72,57.7-1.39.45-13.34-8.58-25.73-18.39l29-35.4,6.24,5.42S350,422.76,353.43,422,363.69,424.13,362.76,426.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M362.76,426.55c-.93,2.42-45.7,56.7-48.72,57.7-1.14.38-9.43-5.68-19.23-13.29l28.76-35.08S350,422.76,353.43,422,363.69,424.13,362.76,426.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M359.94,425.54c-7.73,8.91-38.05,45.6-45,55-.05.08,0,.12.06,0,7.85-8.67,37.89-45.61,45.11-54.93C360.25,425.46,360.11,425.35,359.94,425.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M348.6,423.91a9.5,9.5,0,0,0-2.27,7.28,9.2,9.2,0,0,0,3.18,6c.06,0,.14-.06.09-.11a11,11,0,0,1-.89-13.12C348.77,423.93,348.66,423.84,348.6,423.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M327.39,433.1c-3.06,3.6-5.25,8.88-4.14,13.6,0,.18.3.12.33,0a65.44,65.44,0,0,1,4.31-13.26A.29.29,0,0,0,327.39,433.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M330.8,431.19c-3.05,3.6-5.25,8.88-4.14,13.6,0,.18.31.12.34,0a65,65,0,0,1,4.3-13.26A.3.3,0,0,0,330.8,431.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M334.22,429.28c-3.06,3.6-5.25,8.88-4.14,13.6,0,.19.3.12.33,0a65.23,65.23,0,0,1,4.31-13.26A.3.3,0,0,0,334.22,429.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M337.63,427.37c-3.05,3.6-5.25,8.89-4.14,13.61.05.18.31.12.34,0a65.41,65.41,0,0,1,4.3-13.26A.3.3,0,0,0,337.63,427.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M308.19,471.1c-3.36,4.09,3,9.32,6.37,5.21S311.56,467,308.19,471.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M320.91,421.14c-3,.59-3.47,4.14-2.82,6.59a24.86,24.86,0,0,0,6.59,11c.07.07.15,0,.2,0a.57.57,0,0,0,.83-.41c.35-4.07,1.22-8.39.3-12.44C325.48,423.47,323.8,420.59,320.91,421.14ZM325,432c-.12,2-.34,4-.39,6a74.11,74.11,0,0,1-3.7-6.5,25.12,25.12,0,0,1-1.36-3.36c-.55-1.78-.65-7.87,3.62-5C325.48,424.78,325.11,429.6,325,432Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M318.57,448.88c3.1-2.77,4.89-6.78,7-10.3.22-.36-.1-.74-.44-.82a.13.13,0,0,0-.14-.14,24.82,24.82,0,0,0-11.75,5.12c-2,1.61-3.67,4.75-1.53,7S316.75,450.5,318.57,448.88Zm-3.89.49c-5.16-.11-1.54-5-.06-6.14a27.2,27.2,0,0,1,3.06-1.94,70.71,70.71,0,0,1,6.79-3.14c-1.13,1.66-2.11,3.41-3.17,5.11C320,445.29,317.52,449.43,314.68,449.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M315.87,424.9l-33.23,39.38L182.42,392.92l-9.88-7s-2.84,1.87-7.11,4.16c-5.93,3.19-14.62,7.21-22.27,8.24C130.32,400,111,399.58,100.37,385c-9-12.28-5.89-28.11-5.89-28.11L108.63,351s33.64-27.34,55.22-27.91c9.16-.26,22.42,6.85,34.68,14.25S315.87,424.9,315.87,424.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M172.54,385.88s-2.84,1.87-7.11,4.16c-7.39-9.07-23.07-25.57-23.55-26.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M120.94,341.89c-2,1.36-4,2.8-5.93,4.2s-4,2.66-5.81,4.16-3.68,3.16-5.46,4.81c-.86.79-1.71,1.59-2.54,2.42a23.6,23.6,0,0,0-2.43,2.57c-.06.09.06.19.15.14a26.3,26.3,0,0,0,2.69-2.14l2.81-2.33c1.81-1.5,3.65-3,5.46-4.46s3.45-3.13,5.23-4.65S119,343.49,121,342C121,341.93,121,341.86,120.94,341.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M305.61,421.11c-2,2.12-3.88,4.4-5.76,6.64s-3.76,4.5-5.62,6.77c-3.73,4.54-7.48,9.06-11.15,13.65-2,2.52-4,5.06-5.87,7.69-.08.11.11.25.2.15,4-4.3,7.67-8.88,11.38-13.42s7.44-9.1,11.09-13.69c2-2.52,4.06-5,5.9-7.66C305.86,421.14,305.69,421,305.61,421.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M230.28,426.88c-5.09-4.11-16.67-12.15-21.95-16s-10.5-7.69-15.83-11.42c-1.53-1.07-3.08-2.12-4.62-3.17s-3.15-2-4.65-3.12c-.09-.06-.17.09-.09.15,1.39,1,2.69,2.16,4.05,3.21s2.59,2,3.9,3c2.56,1.94,5.14,3.84,7.72,5.75q7.83,5.82,15.81,11.46c3,2.12,12.34,8.42,15.43,10.44C230.23,427.31,230.45,427,230.28,426.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M263.19,384.63c-4.7-4-15.42-11.68-20.35-15.38s-10-7.51-15-11.23L213,347c-4.82-3.57-9.61-7.2-14.7-10.37-2.79-1.74-5.65-3.35-8.59-4.8a55.6,55.6,0,0,0-8.9-3.76c-.09,0-.14.1-.06.15,2.51,1.44,5.15,2.66,7.7,4.06s5,2.82,7.42,4.34c5.05,3.15,9.82,6.72,14.61,10.25,9.95,7.34,19.88,14.71,29.9,22,5.6,4,16.77,12.41,22.6,16.15C263.15,385.05,263.36,384.77,263.19,384.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpSvg);
export default __webpack_public_path__ + "static/media/OtpSvg.f3d7b37da778b04fa668fcac7c7eefe4.svg";
export { ForwardRef as ReactComponent };